import { DOCUMENTS_OPTIONS, TENANTS } from "../constants"
import { sendToLogServer } from "../core/service/BusinessLogicService"
import { apigateway } from "../intances/apigateway"

export const fetchAcceptanceDocumentTypes = ({ tunnelData }) => {
  // SupportingDocumentType enum in Monorepo
  const SUPPORTING_DOCUMENT_TYPE =
    tunnelData.tenant === TENANTS.RETAIL_IT ? DOCUMENTS_OPTIONS.SAV : DOCUMENTS_OPTIONS.DISTRIBUTOR
  const headers = {
    Authorization: `Bearer ${tunnelData?.access_token}`,
    Accept: "*/*",
    "Content-Type": "application/json"
  }
  return apigateway(tunnelData)
    .get(`${tunnelData.apiUrl}middle-business-service/api/v1/supporting-documents/search/${SUPPORTING_DOCUMENT_TYPE}`, {
      headers
    })
    .then((res) => {
      return res.data
    })
    .catch((error) => {
      console.error("fetchAcceptanceDocumentTypes error : \n", error)
      sendToLogServer(
        "ERROR",
        `There was an error in /api/v1/supporting-documents/search/DISTRIBUTOR endpoint${
          tunnelData.opl
        } : ${JSON.stringify(error)}`
      )
    })
}
